import React, { useMemo } from "react";
import EChart from "./EChart";
import { ECHART_TOOLTIP, ECHART_COLORS } from "../../Utilities/echartsTheme";

const EChartsGauge = ({ value, title = "", max = 100 }) => {
  const option = useMemo(() => {
    const v = Math.min(Math.max(value || 0, 0), max);
    const color = v >= 80 ? ECHART_COLORS.success : v >= 50 ? ECHART_COLORS.accentLight : ECHART_COLORS.danger;

    return {
      tooltip: { ...ECHART_TOOLTIP, formatter: `{a}: ${v}%` },
      series: [
        {
          name: title,
          type: "gauge",
          startAngle: 200,
          endAngle: -20,
          min: 0,
          max,
          radius: "90%",
          center: ["50%", "55%"],
          progress: {
            show: true,
            width: 14,
            roundCap: true,
            itemStyle: { color },
          },
          axisLine: {
            roundCap: true,
            lineStyle: { width: 14, color: [[1, "#E2E8F0"]] },
          },
          pointer: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: { show: false },
          anchor: { show: false },
          title: { show: false },
          detail: {
            valueAnimation: true,
            fontSize: 22,
            fontWeight: "bold",
            color,
            offsetCenter: [0, "0%"],
            formatter: "{value}%",
          },
          data: [{ value: v }],
          animationDuration: 800,
        },
      ],
    };
  }, [value, title, max]);

  return <EChart option={option} />;
};

export default EChartsGauge;
